import { MutationTree } from 'vuex';
import { State } from './detail.store';
import store from '@/store/index';
import { initialState } from '@/store/modules/database/detail/detail.store';

const mutations: MutationTree<State> = {
  setCurrentSubType(state: State, data: any) {
    state.currentSubType = data;
  },
  setDatabaseInstances(state: State, data: any) {
    state.databaseInstances = data;
  },
  setCurrentDatabaseInstance(state: State, data: any) {
    state.currentDatabaseInstance = data;
    store.commit('globalState/app/setUpdateDasboard', data, { root: true });
  },
  setBuckets(state: State, data:any) {
    state.buckets = data;
  },
  setCurrentBucket(state: State, data: any) {
    state.currentBucket = data;
    store.commit('globalState/app/setUpdateDasboard', data, { root: true });
  },
  setClusters(state: State, data:any) {
    state.clusters = data;
  },
  setCurrentCluster(state: State, data: any) {
    state.currentCluster = data;
  },
  setDefaultValues(state: State) {
    Object.assign(state, { ...initialState });
  },
};

export default mutations;
